import React from "react";

const Pagination = React.memo(({ currentPage, totalPages, onPageChange }) => {
  const pages = [];
  const maxVisiblePages = 5;
  
  // Calculate start and end page numbers
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
  
  // Adjust start page if we're near the end
  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return (
    <div className="flex items-center gap-[15px] mt-[70px]">
      <button 
        aria-label="Previous page" 
        className="p-4 group disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <svg
          width="7"
          height="14"
          viewBox="0 0 7 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="transition-colors duration-300 group-hover:stroke-main-black"
            d="M5.80078 1L1.00078 7L5.80078 13"
            stroke="#6D6D6D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      
      {pages.map((page) => (
        <button
          key={page}
          className={`flex items-center justify-center transition-all duration-300 rounded-full w-11 aspect-square ${
            page === currentPage
              ? 'bg-purple text-white'
              : 'bg-purple/10 text-paragraph hover:bg-purple hover:text-white'
          }`}
          onClick={() => onPageChange(page)}
        >
          <span>{page}</span>
        </button>
      ))}
      
      <button 
        aria-label="Next page" 
        className="p-4 group disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <svg
          width="7"
          height="14"
          viewBox="0 0 7 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="transition-colors duration-300 group-hover:stroke-main-black"
            d="M1 1L5.8 7L0.999999 13"
            stroke="#6D6D6D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
});

Pagination.displayName = 'Pagination';

export default Pagination;
